module.exports = __webpack_public_path__ + "static/media/medico.ae4409db.svg";